var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectScanSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 14C22 14.3492 22 14.6822 21.9991 15M14 22C17.7712 22 19.6569 22 20.8284 20.8284C21.4816 20.1752 21.7706 19.3001 21.8985 18",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10C2 9.65081 2 9.31779 2.00093 9M10 2C6.22876 2 4.34315 2 3.17157 3.17157C2.51839 3.82476 2.22938 4.69989 2.10149 6",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2C17.7712 2 19.6569 2 20.8284 3.17157C22 4.34315 22 6.22876 22 10",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.5C4 11.5 6.4 9.5 12 9.5C17.6 9.5 20 11.5 20 11.5",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 10C5.25 10.4142 5.58579 10.75 6 10.75C6.41421 10.75 6.75 10.4142 6.75 10H5.25ZM17.4142 6.08579L16.8839 6.61612L16.8839 6.61612L17.4142 6.08579ZM10 6.25H14V4.75H10V6.25ZM6.75 10V9.5H5.25V10H6.75ZM17.25 9.5V10H18.75V9.5H17.25ZM14 6.25C14.964 6.25 15.6116 6.25159 16.0946 6.31654C16.5561 6.37858 16.7536 6.4858 16.8839 6.61612L17.9445 5.55546C17.4891 5.09999 16.9223 4.91432 16.2945 4.82991C15.6883 4.74841 14.9216 4.75 14 4.75V6.25ZM18.75 9.5C18.75 8.57839 18.7516 7.81174 18.6701 7.20552C18.5857 6.57773 18.4 6.01093 17.9445 5.55546L16.8839 6.61612C17.0142 6.74643 17.1214 6.94393 17.1835 7.40539C17.2484 7.88843 17.25 8.53599 17.25 9.5H18.75ZM10 4.75C9.07839 4.75 8.31174 4.74841 7.70552 4.82991C7.07773 4.91432 6.51093 5.09999 6.05546 5.55546L7.11612 6.61612C7.24643 6.4858 7.44393 6.37858 7.90539 6.31654C8.38843 6.25159 9.03599 6.25 10 6.25V4.75ZM6.75 9.5C6.75 8.53599 6.75159 7.88843 6.81654 7.40539C6.87858 6.94393 6.9858 6.74643 7.11612 6.61612L6.05546 5.55546C5.59999 6.01093 5.41432 6.57773 5.32991 7.20552C5.24841 7.81174 5.25 8.57839 5.25 9.5H6.75Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.5C15.8856 18.5 16.8284 18.5 17.4142 17.9142C18 17.3284 18 16.3856 18 14.5V14M10 18.5C8.11438 18.5 7.17157 18.5 6.58579 17.9142C6 17.3284 6 16.3856 6 14.5V14",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectScanSvgrepoCom);
export default __webpack_public_path__ + "static/media/object-scan-svgrepo-com.46d68817da570775ef53547c90cf70ed.svg";
export { ForwardRef as ReactComponent };